import { useInView } from "framer-motion";
import { useRef } from "react";
import CountUp from "react-countup";

const STATS = [
  { value: 98, suffix: "%", label: "Client Satisfaction", desc: "Driven by consistent, transparent communication." },
  { value: 12, suffix: "+", label: "Years of Experience", desc: "Combined market expertise across cycles." },
  { value: 25, suffix: "+", label: "Investment Solutions", desc: "Across equity, debt, hybrid and alternatives." },
  { value: 24, suffix: "/7", label: "Personalized Support", desc: "Always-on access to the Axomind team." },
];

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section data-testid="stats-section" className="relative py-24 lg:py-32 bg-gradient-to-b from-[#080808] via-[#050505] to-[#080808] border-y border-white/5 overflow-hidden">
      <div className="absolute -top-40 -right-32 w-[500px] h-[500px] rounded-full bg-[#D4AF37]/10 blur-[160px] pointer-events-none" />
      <div className="absolute -bottom-40 -left-32 w-[500px] h-[500px] rounded-full bg-[#D4AF37]/5 blur-[160px] pointer-events-none" />

      <div ref={ref} className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-xs tracking-[0.35em] uppercase text-[#D4AF37]">By the Numbers</p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-white mt-4">
            A track record of trust.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {STATS.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="glass rounded-2xl p-7 lg:p-9 text-center hover:border-[#D4AF37]/40 transition"
            >
              <div className="font-display font-bold text-5xl lg:text-6xl text-gold-gradient leading-none">
                {inView ? <CountUp end={s.value} duration={2.4} /> : 0}
                <span>{s.suffix}</span>
              </div>
              <div className="font-display font-semibold text-white mt-4">{s.label}</div>
              <div className="text-sm text-gray-400 mt-2 leading-relaxed">{s.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
